__webpack_require__.p = "/vr/archondissa/_next/";